export default __webpack_public_path__ + "static/media/Stories.165c92ac.png";